import { Background } from 'components/public-layout/image/background';
import { forwardRef } from 'react';

type SceneAnchorProps = {
  /** Show the CSS glow layers (scene still loading or WebGL unavailable). */
  showFallback: boolean;
};

/**
 * Layout slot for the three.js locker scene: reserves the illustration space
 * in the branded column and acts as the camera framing anchor (the full-bleed
 * canvas in layout-wrapper glues the cabinet to this box via setViewOffset).
 * The CSS glows only render while the scene is not live — the full-bleed
 * canvas sits below this layer, so leaving them on would wash out the
 * cabinet. Hidden below the `md` (768px) breakpoint.
 */
const SceneAnchor = forwardRef<HTMLDivElement, SceneAnchorProps>(
  ({ showFallback }, ref) => {
    return (
      <div
        ref={ref}
        aria-hidden
        className="relative mb-[-56px] mt-[16px] hidden h-[280px] w-[380px] md:block"
      >
        {showFallback ? <Background /> : null}
      </div>
    );
  }
);

SceneAnchor.displayName = 'SceneAnchor';

export default SceneAnchor;
